import store from '@/store';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import { nativeShareText } from '@/common/utils/module/NativeRequest';
import { showTextModal } from '@/common/utils/ModalState';

import { getCurrentPath, getImagePath, isApp, isEmpty, isIPad, isIPhone, isSafari } from '@/common/utils/Util';

export const businessShare = () => {
  const business = store.getters['business/getDetail'];
  if (business.isShareWish === false) {
    showTextModal('이 기업은 공유를 원하지 않는 기업입니다.', '확인');
    return;
  }
  const form = `[간판 ON] \n\n비즈니스 소개장\n비즈니스명 : ${business.name}\n상세 주소 : ${business.address} ${
    business.addressDetail ? '(' + business.addressDetail + ')' : ''
  }\n비즈니스 전화번호 :  ${business.phone ? business.phone : '-'} \n ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/share/${
    business.businessNo
  }`;
  if (isApp()) {
    nativeShareText(form);
  } else {
    navigator.clipboard.writeText(form).then(() => {
      if (!isIPhone() && !isIPad()) {
        showTextModal('현재 비즈니스 내용이 복사되었습니다.', '확인');
      }
    });
  }
};
// 260626: 비즈 상세 채널 공유(카톡/문자) 단일화.
//   detail.vue 본문 4그리드(내 업체)와 헤더 공유 바텀시트(남의 업체)가 공용으로 호출 → split-brain 방지.
//   기존 businessShare()(네이티브 텍스트 공유/복사)와는 별개 경로(카톡 피드/문자 OG).
export const shareBusinessChannel = method => {
  const business = store.getters['business/getDetail'];
  if (business.isShareWish === false) {
    showTextModal('이 기업은 공유를 원하지 않는 기업입니다.', '확인');
    return;
  }
  const shareUrl = `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/share/${business.businessNo}`;
  const imageUrl = isEmpty(business?.imageList)
    ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    : getImagePath(business?.imageList[0]?.storedFileName);

  if (method === 'sms') {
    const ogUrl = `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/api/og/business/${business.businessNo}`;
    const body = `${business.name}\n${business.address || ''}\n${ogUrl}`;
    window.location.href = `smsto:?body=${encodeURIComponent(body)}`;
    return;
  }

  if (method === 'kakao') {
    Kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        title: business.name,
        description: `${business.address || ''}`,
        imageUrl: imageUrl,
        link: { webUrl: shareUrl, mobileWebUrl: shareUrl }
      },
      buttons: [{ title: '기업 보기', link: { webUrl: shareUrl, mobileWebUrl: shareUrl } }]
    });
  }
};
export const businessMarketingShare = () => {
  const marketing = store.getters['business/getDetail']; // 부고장 정보

  // 260618: 카톡 링크 언펄에 마케팅 대표 이미지가 뜨도록 OG 엔드포인트 공유 (비즈니스/명함 SMS와 동일 패턴).
  //   크롤러=동적 OG, 사람=클릭 시 /business/marketing/share/{no} SPA로 리다이렉트.
  const form = `[간판 ON] \n\n마케팅 소개장\n${marketing.title}\n  \n ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/api/og/marketing/${marketing.marketingNo}`;
  if (isApp()) {
    nativeShareText(form);
  } else {
    navigator.clipboard.writeText(form).then(() => {
      if (!isIPhone() && !isIPad()) {
        showTextModal('현재 이벤트 내용이 복사되었습니다.', '확인');
      }
    });
  }
};

/**
 * 카카오 공유하기 — 단순 공유만 수행
 * 260506 오후 회의: 4시간 즉시 공유 충전 폐기. 추천 가입 시 슈퍼배터리(168h)는 ChargeShare 페이지에서만 처리.
 */
export const businessKakaoShare = async () => {
  const business = store.getters['business/getDetail'];
  if (business.isShareWish === false) {
    showTextModal('이 기업은 공유를 원하지 않는 기업입니다.', '확인');
    return;
  }
  buildKakaoShareButton(business, `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/share/${business.businessNo}`);
};

// 카카오 버튼 생성 공통 함수 (shareUrl 파라미터로 충전/비충전 모드 구분)
const buildKakaoShareButton = (business, linkUrl) => {
  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `[간판 ON] \n\n비즈니스 소개장\n비즈니스명 : ${business.name}\n상세 주소 : ${business.address} ${
        business.addressDetail ? '(' + business.addressDetail + ')' : ''
      }\n비즈니스 전화번호 :  ${business.phone ? business.phone : '-'}`,
      imageUrl: isEmpty(business?.imageList)
        ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
        : getImagePath(business?.imageList[0]?.storedFileName),
      link: { webUrl: linkUrl, mobileWebUrl: linkUrl }
    },
    itemContent: {
      profileText: '간판 ON',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
    },
    buttons: [
      { title: '확인하기', link: { webUrl: linkUrl, mobileWebUrl: linkUrl } }
    ]
  });
};
export const businessMarketingKakaoShare = () => {
  const marketing = store.getters['business/getDetail'];
  // 260618: 카카오 SDK 피드 카드에도 이벤트 본문 노출 (OG description과 별개 경로 — 앱 공유 버튼).
  //   개행·연속공백 한 칸으로 정리 후 100자. 카드엔 1~2줄만 표시됨.
  const marketingDesc = (marketing?.contents || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `${marketing.title}`,
      description: marketingDesc,
      // 260618: 이미지 없을 때 폴백을 라앤라 로고(AppIcon.png)→간판ON 로고(og-jumpon.png)로 교체
      imageUrl: isEmpty(marketing?.imageList)
        ? `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/og-jumpon.png`
        : getImagePath(marketing?.imageList[0]?.storedFileName),
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/marketing/share/${marketing.marketingNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/marketing/share/${marketing.marketingNo}`
      }
    },
    itemContent: {
      profileText: '간판 ON',
      // 260618: 프로필 아이콘 라앤라 로고(AppIcon.png)→간판ON 로고(og-jumpon.png)
      profileImageUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/og-jumpon.png`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/marketing/share/${marketing.marketingNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/marketing/share/${marketing.marketingNo}`
        }
      }
    ]
  });
};
export const businessLike = () => {
  return store.dispatch('business/likeBusiness');
};

export const businessDonationShare = () => {
  const donation = store.getters['business/getDetail']; // 부고장 정보

  const form = `[간판 ON] \n기부천사 : ${donation.title}\n  \n ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`;
  if (isApp()) {
    nativeShareText(form);
  } else {
    navigator.clipboard.writeText(form).then(() => {
      if (!isIPhone() && !isIPad()) {
        showTextModal('현재 기부 내용이 복사되었습니다.', '확인');
      }
    });
  }
};

export const businessDonationKakaoShare = () => {
  const donation = store.getters['business/getDetail'];
  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `기부천사 : ${donation.title} \n${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`,
      imageUrl: isEmpty(donation?.imageList)
        ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
        : getImagePath(donation?.imageList[0]?.storedFileName),
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`
      }
    },
    itemContent: {
      profileText: '간판 ON',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/donation/share/${donation.donationNo}`
        }
      }
    ]
  });
};

export const businessJobShare = () => {
  const job = store.getters['business/getDetail']; // 부고장 정보

  const form = `[간판 ON] \n구인 : ${job.title}\n  \n ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`;
  if (isApp()) {
    nativeShareText(form);
  } else {
    navigator.clipboard.writeText(form).then(() => {
      if (!isIPhone() && !isIPad()) {
        showTextModal('현재 구인 내용이 복사되었습니다.', '확인');
      }
    });
  }
};


export const businessJobKakaoShare = () => {
  const job = store.getters['business/getDetail'];
  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `구인 : ${job.title} \n${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`,
      imageUrl: isEmpty(job?.imageList)
        ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
        : getImagePath(job?.imageList[0]?.storedFileName),
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`
      }
    },
    itemContent: {
      profileText: '간판 ON',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=3`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/business/job/share/${job.jobNo}`
        }
      }
    ]
  });
};
